const pageType =
  window.ShopifyAnalytics &&
  window.ShopifyAnalytics.meta &&
  window.ShopifyAnalytics.meta.page &&
  window.ShopifyAnalytics.meta.page.pageType;

if (pageType !== "cart") {
  let counter = 0;
  const interval = setInterval(() => {
    const footerPrice = document.querySelector(".header-mini-cart-footer");
   
    if (footerPrice){
      handleTEBox();
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
} else {
  let counter = 0;
  const interval = setInterval(() => {
    const vatInputWrapper = document.querySelector(".bss-b2b-vat-input-wrapper");

    if (vatInputWrapper) {
      handleTEBox();
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
}

function handleTEBox() {
  const translations = BSS_B2B.te.teTranslations;
  const headerText = document.querySelector(
    ".bss-b2b-translation-vat-form_header_text"
  );
  if (headerText) {
    headerText.innerText = translations.form_header_text;
  }

  const subtitleText = document.querySelector(
    ".bss-b2b-translation-vat-form_subtitle_text"
  );
  if (subtitleText) {
    subtitleText.innerText = translations.form_subtitle_text;
  }

  const successMessages = [
    document.querySelector(".bss-b2b-translation-vat-form_success_message"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_uk"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_abn"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_gst"),
    document.querySelector(
      ".bss-b2b-translation-vat-form_success_message_us_ein"
    ),
  ];

  successMessages.forEach((msg, index) => {
    if (msg) {
      switch (index) {
        case 0:
          msg.innerText = translations.form_success_message || "";
          break;
        case 1:
          msg.innerText = translations.form_success_message_uk || "";
          break;
        case 2:
          msg.innerText = translations.form_success_message_abn || "";
          break;
        case 3:
          msg.innerText = translations.form_success_message_gst || "";
          break;
        case 4:
          msg.innerText = translations.form_success_message_us_ein || "";
          break;
      }
    }
  });

  const errorMessages = [
    document.querySelector(".bss-b2b-translation-vat-form_error_message"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_uk"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_abn"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_gst"),
    document.querySelector(
      ".bss-b2b-translation-vat-form_error_message_us_ein"
    ),
    document.querySelector(
      ".bss-b2b-translation-vat-form_validate_country_code_message"
    ),
  ];

  errorMessages.forEach((msg, index) => {
    if (msg) {
      switch (index) {
        case 0:
          msg.innerText = translations.form_error_message || "";
          break;
        case 1:
          msg.innerText = translations.form_error_message_uk || "";
          break;
        case 2:
          msg.innerText = translations.form_error_message_abn || "";
          break;
        case 3:
          msg.innerText = translations.form_error_message_gst || "";
          break;
        case 4:
          msg.innerText = translations.form_error_message_us_ein || "";
          break;
        case 5:
          msg.innerText = translations.form_validate_country_code_message || "";
          break;
      }
    }
  });
}

document.addEventListener('cart:rerendered', ()=> {
  if(BSS_B2B){
    BSS_B2B.observer.cartSubject.listenCartCheckout();
  }
})
if('/pages/b2b' === window.location.pathname) {
  translateCountry();
}
function translateCountry(){
  const interval = setInterval(() => {
    const element = document.querySelector("#country-list");
    if (element) {
      handleTranslateCountry();
      clearInterval(interval);
      clearTimeout(timeout);
    }
  }, 100);
  
  const timeout = setTimeout(() => {
    clearInterval(interval);
  }, 8000);
}

function handleTranslateCountry(){
  const countryList = document.querySelectorAll("#country-list li");

const translations = {
  "Afghanistan": "Afghanistan",
  "Aland Islands": "Ålandinseln",
  "Albania": "Albanien",
  "Algeria": "Algerien",
  "Andorra": "Andorra",
  "Angola": "Angola",
  "Anguilla": "Anguilla",
  "Antigua & Barbuda": "Antigua und Barbuda",
  "Argentina": "Argentinien",
  "Armenia": "Armenien",
  "Aruba": "Aruba",
  "Ascension Island": "Ascension",
  "Australia": "Australien",
  "Austria": "Österreich",
  "Azerbaijan": "Aserbaidschan",
  "Bahamas": "Bahamas",
  "Bahrain": "Bahrain",
  "Bangladesh": "Bangladesch",
  "Barbados": "Barbados",
  "Belarus": "Weißrussland",
  "Belgium": "Belgien",
  "Belize": "Belize",
  "Benin": "Benin",
  "Bermuda": "Bermuda",
  "Bhutan": "Bhutan",
  "Bolivia": "Bolivien",
  "Bosnia & Herzegovina": "Bosnien und Herzegowina",
  "Botswana": "Botswana",
  "Bouvet Island": "Bouvetinsel",
  "Brazil": "Brasilien",
  "British Indian Ocean Territory": "Britisches Territorium im Indischen Ozean",
  "British Virgin Islands": "Britische Jungferninseln",
  "Brunei": "Brunei",
  "Bulgaria": "Bulgarien",
  "Burkina Faso": "Burkina Faso",
  "Burundi": "Burundi",
  "Cambodia": "Kambodscha",
  "Cameroon": "Kamerun",
  "Canada": "Kanada",
  "Cape Verde": "Kap Verde",
  "Caribbean Netherlands": "Karibische Niederlande",
  "Cayman Islands": "Kaimaninseln",
  "Central African Republic": "Zentralafrikanische Republik",
  "Chad": "Tschad",
  "Chile": "Chile",
  "China": "China",
  "Christmas Island": "Weihnachtsinsel",
  "Cocos (Keeling) Islands": "Kokosinseln",
  "Colombia": "Kolumbien",
  "Comoros": "Komoren",
  "Congo - Brazzaville": "Kongo-Brazzaville",
  "Congo - Kinshasa": "Kongo-Kinshasa",
  "Cook Islands": "Cookinseln",
  "Costa Rica": "Costa Rica",
  "Côte d'Ivoire": "Elfenbeinküste",
  "Croatia": "Kroatien",
  "Cuba": "Kuba",
  "Curaçao": "Curaçao",
  "Cyprus": "Zypern",
  "Czechia": "Tschechien",
  "Denmark": "Dänemark",
  "Djibouti": "Dschibuti",
  "Dominica": "Dominica",
  "Dominican Republic": "Dominikanische Republik",
  "Ecuador": "Ecuador",
  "Egypt": "Ägypten",
  "El Salvador": "El Salvador",
  "Equatorial Guinea": "Äquatorialguinea",
  "Eritrea": "Eritrea",
  "Estonia": "Estland",
  "Eswatini": "Eswatini",
  "Ethiopia": "Äthiopien",
  "Falkland Islands": "Falklandinseln",
  "Faroe Islands": "Färöer-Inseln",
  "Fiji": "Fidschi",
  "Finland": "Finnland",
  "France": "Frankreich",
  "French Guiana": "Französisch-Guayana",
  "French Polynesia": "Französisch-Polynesien",
  "French Southern Territories": "Französische Süd- und Antarktisgebiete",
  "Gabon": "Gabun",
  "Gambia": "Gambia",
  "Georgia": "Georgien",
  "Germany": "Deutschland",
  "Ghana": "Ghana",
  "Gibraltar": "Gibraltar",
  "Greece": "Griechenland",
  "Greenland": "Grönland",
  "Grenada": "Grenada",
  "Guadeloupe": "Guadeloupe",
  "Guam": "Guam",
  "Guatemala": "Guatemala",
  "Guernsey": "Guernsey",
  "Guinea": "Guinea",
  "Guinea-Bissau": "Guinea-Bissau",
  "Guyana": "Guyana",
  "Haiti": "Haiti",
  "Heard & McDonald Islands": "Heard und McDonaldinseln",
  "Honduras": "Honduras",
  "Hong Kong SAR": "Hongkong",
  "Hungary": "Ungarn",
  "Iceland": "Island",
  "India": "Indien",
  "Indonesia": "Indonesien",
  "Iran": "Iran",
  "Iraq": "Irak",
  "Ireland": "Irland",
  "Isle of Man": "Isle of Man",
  "Israel": "Israel",
  "Italy": "Italien",
  "Jamaica": "Jamaika",
  "Japan": "Japan",
  "Jersey": "Jersey",
  "Jordan": "Jordanien",
  "Kazakhstan": "Kasachstan",
  "Kenya": "Kenia",
  "Kiribati": "Kiribati",
  "Kosovo": "Kosovo",
  "Kuwait": "Kuwait",
  "Kyrgyzstan": "Kirgisistan",
  "Laos": "Laos",
  "Latvia": "Lettland",
  "Lebanon": "Libanon",
  "Lesotho": "Lesotho",
  "Liberia": "Liberia",
  "Libya": "Libyen",
  "Liechtenstein": "Liechtenstein",
  "Lithuania": "Litauen",
  "Luxembourg": "Luxemburg",
  "Macao SAR China": "Macao",
  "Madagascar": "Madagaskar",
  "Malawi": "Malawi",
  "Malaysia": "Malaysia",
  "Maldives": "Malediven",
  "Mali": "Mali",
  "Malta": "Malta",
  "Martinique": "Martinique",
  "Mauritania": "Mauretanien",
  "Mauritius": "Mauritius",
  "Mayotte": "Mayotte",
  "Mexico": "Mexiko",
  "Moldova": "Moldawien",
  "Monaco": "Monaco",
  "Mongolia": "Mongolei",
  "Montenegro": "Montenegro",
  "Montserrat": "Montserrat",
  "Morocco": "Marokko",
  "Mozambique": "Mosambik",
  "Myanmar (Burma)": "Myanmar",
  "Namibia": "Namibia",
  "Nauru": "Nauru",
  "Nepal": "Nepal",
  "Netherlands": "Niederlande",
  "Netherlands Antilles": "Niederländische Antillen",
  "New Caledonia": "Neukaledonien",
  "New Zealand": "Neuseeland",
  "Nicaragua": "Nicaragua",
  "Niger": "Niger",
  "Nigeria": "Nigeria",
  "Niue": "Niue",
  "Norfolk Island": "Norfolkinsel",
  "North Korea": "Nordkorea",
  "North Macedonia": "Nordmazedonien",
  "Norway": "Norwegen",
  "Oman": "Oman",
  "Pakistan": "Pakistan",
  "Palestinian Territories": "Palästinensische Gebiete",
  "Panama": "Panama",
  "Papua New Guinea": "Papua-Neuguinea",
  "Paraguay": "Paraguay",
  "Peru": "Peru",
  "Philippines": "Philippinen",
  "Pitcairn Islands": "Pitcairninseln",
  "Poland": "Polen",
  "Portugal": "Portugal",
  "Qatar": "Katar",
  "Reunion": "Réunion",
  "Romania": "Rumänien",
  "Russia": "Russland",
  "Rwanda": "Ruanda",
  "Samoa": "Samoa",
  "San Marino": "San Marino",
  "Sao Tome And Principe": "São Tomé und Príncipe",
  "Saudi Arabia": "Saudi-Arabien",
  "Senegal": "Senegal",
  "Serbia": "Serbien",
  "Seychelles": "Seychellen",
  "Sierra Leone": "Sierra Leone",
  "Singapore": "Singapur",
  "Sint Maarten": "Sint Maarten",
  "Slovakia": "Slowakei",
  "Slovenia": "Slowenien",
  "Solomon Islands": "Salomonen",
  "Somalia": "Somalia",
  "South Africa": "Südafrika",
  "South Georgia & South Sandwich Islands": "Südgeorgien und die Südlichen Sandwichinseln",
  "South Korea": "Südkorea",
  "South Sudan": "Südsudan",
  "Spain": "Spanien",
  "Sri Lanka": "Sri Lanka",
  "St. Barthélemy": "Saint-Barthélemy",
  "St. Helena": "Sankt Helena",
  "St. Kitts & Nevis": "St. Kitts und Nevis",
  "St. Lucia": "St. Lucia",
  "St. Martin": "Saint-Martin",
  "St. Pierre & Miquelon": "Saint-Pierre und Miquelon",
  "St. Vincent & Grenadines": "St. Vincent und die Grenadinen",
  "Sudan": "Sudan",
  "Suriname": "Suriname",
  "Svalbard & Jan Mayen": "Spitzbergen und Jan Mayen",
  "Sweden": "Schweden",
  "Switzerland": "Schweiz",
  "Syria": "Syrien",
  "Taiwan": "Taiwan",
  "Tajikistan": "Tadschikistan",
  "Tanzania": "Tansania",
  "Thailand": "Thailand",
  "Timor-Leste": "Osttimor",
  "Togo": "Togo",
  "Tokelau": "Tokelau",
  "Tonga": "Tonga",
  "Trinidad & Tobago": "Trinidad und Tobago",
  "Tristan da Cunha": "Tristan da Cunha",
  "Tunisia": "Tunesien",
  "Turkey": "Türkei",
  "Turkmenistan": "Turkmenistan",
  "Turks & Caicos Islands": "Turks- und Caicosinseln",
  "Tuvalu": "Tuvalu",
  "U.S. Outlying Islands": "US-Außengebiete",
  "Uganda": "Uganda",
  "Ukraine": "Ukraine",
  "United Arab Emirates": "Vereinigte Arabische Emirate",
  "United Kingdom": "Vereinigtes Königreich",
  "United States": "Vereinigte Staaten",
  "Uruguay": "Uruguay",
  "Uzbekistan": "Usbekistan",
  "Vanuatu": "Vanuatu",
  "Vatican City": "Vatikanstadt",
  "Venezuela": "Venezuela",
  "Vietnam": "Vietnam",
  "Wallis & Futuna": "Wallis und Futuna",
  "Western Sahara": "Westsahara",
  "Yemen": "Jemen",
  "Zambia": "Sambia",
  "Zimbabwe": "Simbabwe"
};

countryList.forEach(li => {
  const originalName = li.textContent.trim();
  const germanName = translations[originalName];
  if (germanName) {
    li.textContent = germanName;
  }
});
}